import React, {PropsWithChildren, useContext, useEffect, useState} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {getNmiSettings} from "../api/NmiApi";

interface NmiContextState {
    tokenizationKey: string;
    isLoading: boolean;
    hasError: boolean;
}

export const NmiContext = React.createContext({} as NmiContextState);

export const NmiProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);
    const isNmiEnabled = Boolean(data.company?.is_nmi_enabled);
    const [tokenizationKey, setTokenizationKey] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [hasError, setHasError] = useState<boolean>(false);

    useEffect(() => {
        if (!isNmiEnabled || tokenizationKey) {
            return;
        }
        let isUseEffectMounted = true;
        setIsLoading(true);
        getNmiSettings()
            .then((settings) => {
                if (!isUseEffectMounted) {
                    return;
                }
                if (settings?.tokenize_key) {
                    setTokenizationKey(settings.tokenize_key);
                } else {
                    setHasError(true);
                }
            })
            .catch(() => {
                if (isUseEffectMounted) {
                    setHasError(true);
                }
            })
            .finally(() => {
                if (isUseEffectMounted) {
                    setIsLoading(false);
                }
            });
        return () => {
            isUseEffectMounted = false;
        };
    }, [isNmiEnabled, tokenizationKey]);

    return (
        <NmiContext.Provider value={{tokenizationKey, isLoading, hasError}}>
            {children}
        </NmiContext.Provider>
    );
};
